import {
    displayDiffFromAverageDollar,
    displayDiffFromAverageUnit,
    displayDollars,
    displayUnits,
    getAverageDollarFormat,
    getAverageUnitFormat,
    getDollarsFormat,
    getUnitsFormat
} from "./SummaryDisplayFunctions";

export const displayFunctions = {
    Dollars: {
        valueKey: 'dollars',
        countKey: 'dollarCount',
        averageKey: 'averageDollarCount',
        diffKey: 'diffFromAverageDollar',
        yagoKey: 'yagoDollars',
        formatTotal: getDollarsFormat,
        displayFunction: displayDollars,
        displayAverageFunction: getAverageDollarFormat,
        displayDiffFromAverageFunction: displayDiffFromAverageDollar
    },
    Units: {
        valueKey: 'units',
        countKey: 'unitCount',
        averageKey: 'averageUnitCount',
        diffKey: 'diffFromAverageUnit',
        formatTotal: getUnitsFormat,
        displayFunction: displayUnits,
        displayAverageFunction: getAverageUnitFormat,
        displayDiffFromAverageFunction: displayDiffFromAverageUnit
    }
}